import React from 'react';
import SpecialEducationPageHeader from './specialeducation/SpecialEducationPageHeader';
import SpecialEducationPageSession from './specialeducation/SpecialEducationPageSession';

function SpecialEducationPage() {
  return (
    <div className="page-wrapper">
      <SpecialEducationPageHeader />
      <SpecialEducationPageSession />
    </div>
  );
}

export default SpecialEducationPage;
